import { usePermissions } from "components/context/permissionsContext";

export const useAccountPermission = () => {
  const { userPermissions } = usePermissions();

  const hasSendInvitePermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Account" &&
      item.action === "SendInvite" &&
      item.hasPermission
  );

  const AccountPermissionProps = {
    hasSendInvitePermission,
  };

  return {
    AccountPermissionProps,
  };
};
